import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import type { AnalyticsRangeOption } from "@/types";

interface DateRangeSelectorProps {
  value: string;
  options: AnalyticsRangeOption[];
  onChange: (value: string) => void;
  className?: string;
}

export function DateRangeSelector({ value, options, onChange, className }: DateRangeSelectorProps) {
  return (
    <Tabs value={value} onValueChange={onChange} className={cn("w-full sm:w-auto", className)}>
      <TabsList className="grid w-full grid-cols-2 gap-2 bg-transparent p-0 sm:inline-flex sm:w-auto">
        {options.map((option) => (
          <TabsTrigger
            key={option.key}
            value={option.key}
            className="data-[state=active]:bg-orange-500 data-[state=active]:text-white"
          >
            {option.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
